import type { TreatState } from "@/lib/types";

export const STATE_LABEL: Record<TreatState, string> = {
  open: "모집중",
  full: "정원마감",
  closed: "종료",
  done: "지난 모임",
};

// 상태 뱃지 — 서버 state_txt 우선
export const STATE_BADGE: Record<TreatState, string> = {
  open: "bg-secondary-100 text-secondary-900",
  full: "bg-accent-100 text-accent-900",
  closed: "bg-background-200 text-foreground-500",
  done: "bg-background-200 text-foreground-500",
};

// 카드 테두리 색 (open 초록 / full 주황 / closed·done 회색)
export const STATE_BORDER: Record<TreatState, string> = {
  open: "border-secondary-400",
  full: "border-accent-400",
  closed: "border-background-200",
  done: "border-background-200",
};

// 카드 왼쪽 굵은 띠 색
export const STATE_STRIP: Record<TreatState, string> = {
  open: "bg-secondary-500",
  full: "bg-accent-500",
  closed: "bg-background-300",
  done: "bg-background-300",
};

export function stateLabel(state?: string, stateTxt?: string): string {
  if (stateTxt) return stateTxt;
  const s = (state ?? "open") as TreatState;
  return STATE_LABEL[s] ?? state ?? "";
}

// closed / done 은 흐리게 처리
export function isDim(state?: string): boolean {
  return state === "closed" || state === "done";
}

export interface TreatCountdown {
  text: string;
  urgent: boolean;
}

// 폭파까지 남은 초 표기. 1시간 이상 "1:12:30", 미만 "38:12"
// 10분 미만이면 urgent(빨강 + 깜빡임)
export function formatCountdown(totalSeconds: number): TreatCountdown {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  const urgent = s < 600;
  if (h > 0) return { text: `${h}:${pad(m)}:${pad(sec)}`, urgent };
  return { text: `${pad(m)}:${pad(sec)}`, urgent };
}

// "2026-09-14" → "2026.09.14"
export function formatDate(value?: string): string {
  if (!value) return "";
  const d = new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return value;
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}.${mo}.${day}`;
}